import { seoOgType } from './SeoStore';

export const updateSeoOgType = (value) => seoOgType.update(oldValue => value);
